module.exports = __webpack_public_path__ + "img/enterprise.96542d30.png";